import { Fragment } from 'react';

import useLscOfferingInstanceOrgUnitEdit from './UseLscOfferingInstanceOrgUnitEdit';

import LscOfferingManagementContextLoadingModal from '../../LscOfferingManagementContextLoadingModal';

import OfferingInstanceOrgUnitEditForm from '../../../components/forms/offeringInstanceOrgUnit/OfferingInstanceOrgUnitEditForm';

import { EDIT_VIEW_TYPE_ADDITIONAL_OFFERING, EDIT_VIEW_TYPE_MAIN_OFFERING, EDIT_VIEW_TYPE_SINGLE_OFFERING } from '../../../utils/OfferingManagementConstants';

import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import { SAVING_MSG } from '@usas/ui-web/utils/Constants';
import { convertNumberToCurrencyString } from '@usas/ui-web/utils/CurrencyUtils';

const LscOfferingInstanceOrgUnitEdit = () => {
  const {
    isSaving,
    state,
    onSubmitOfferingInstanceOrgUnitForm,
    onBackClicked,
    onDeleteClicked,
    onDeletePopupConfirmClicked,
    onDeletePopupCancelClicked
  } = useLscOfferingInstanceOrgUnitEdit();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>{state.viewType === EDIT_VIEW_TYPE_ADDITIONAL_OFFERING ? 'Edit Offering Period' : 'Edit LSC Offering'}</Headings.H3>
        </div>
      </div>
      {state.viewType === EDIT_VIEW_TYPE_SINGLE_OFFERING
        ? ( // Can edit fee and dates
          <OfferingInstanceOrgUnitEditForm
            reportPeriodObj={state.reportPeriodObj}
            orgUnitObj={state.orgUnitObj}
            offeringInstanceObj={state.offeringInstanceObj}
            offeringInstanceOrgUnitId={state.offeringInstanceOrgUnitId}
            isFeeReadOnly={false}
            hideDateFields={false}
            hideOrgUnitName={false}
            onSubmitFormCallback={onSubmitOfferingInstanceOrgUnitForm}
            onBackClicked={onBackClicked}
            onDeleteClicked={onDeleteClicked} />
        ) : state.viewType === EDIT_VIEW_TYPE_MAIN_OFFERING
          ? ( // Can only edit fee, no dates or delete button
            <OfferingInstanceOrgUnitEditForm
              reportPeriodObj={state.reportPeriodObj}
              orgUnitObj={state.orgUnitObj}
              offeringInstanceObj={state.offeringInstanceObj}
              offeringInstanceOrgUnitId={state.offeringInstanceOrgUnitId}
              hideOrgUnitName={false}
              isFeeReadOnly={false}
              hideDateFields={true}
              onSubmitFormCallback={onSubmitOfferingInstanceOrgUnitForm}
              onBackClicked={onBackClicked} />
          ) : state.viewType === EDIT_VIEW_TYPE_ADDITIONAL_OFFERING
            ? ( // Can edit dates
              <OfferingInstanceOrgUnitEditForm
                reportPeriodObj={state.reportPeriodObj}
                orgUnitObj={state.orgUnitObj}
                offeringInstanceObj={state.offeringInstanceObj}
                offeringInstanceOrgUnitId={state.offeringInstanceOrgUnitId}
                hideOrgUnitName={false}
                isFeeReadOnly={true}
                hideDateFields={false}
                onSubmitFormCallback={onSubmitOfferingInstanceOrgUnitForm}
                onBackClicked={onBackClicked}
                onDeleteClicked={onDeleteClicked} />
            ) : <Fragment />
      }
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={state.viewType === EDIT_VIEW_TYPE_ADDITIONAL_OFFERING ? 'Delete Offering Period?' : 'Delete LSC Offering?'}
        displayPopUp={state.displayDeletePopup === true}
        onModalCanceled={onDeletePopupCancelClicked}>
        <div className="row">
          <div className="col-xs-12">
            <p><b>LSC</b>: &nbsp;{state.orgUnitObj?.orgUnitName}</p>
            <p><b>Offering Name</b>: &nbsp;{state.deletePopupOfferingObj?.offeringName}</p>
            <p><b>Price</b>: &nbsp;${convertNumberToCurrencyString(state.deletePopupOfferingObj?.feeAmount)}</p>
            <p><b>Registration Start/End Date</b>: &nbsp;{state.deletePopupOfferingObj?.registrationStartDate} - {state.deletePopupOfferingObj?.registrationEndDate}</p>
            <p><b>Effective/Expiration Date</b>: &nbsp;{state.deletePopupOfferingObj?.effectiveDate} - {state.deletePopupOfferingObj?.expirationDate}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={onDeletePopupConfirmClicked}>Delete</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onDeletePopupCancelClicked}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <LscOfferingManagementContextLoadingModal
        isLoading={isSaving}
        loadingMessage={SAVING_MSG}
        isError={state.pageErrorMessage !== ''}
        errorMessage={state.pageErrorMessage} />
    </Fragment>
  );
};

export default LscOfferingInstanceOrgUnitEdit;